export var ControllerActivity;
(function (ControllerActivity) {
    ControllerActivity[ControllerActivity["None"] = 0] = "None";
    ControllerActivity[ControllerActivity["ChangeDeviceState"] = 1] = "ChangeDeviceState";
})(ControllerActivity || (ControllerActivity = {}));
export class ChatGptConfiguration {
    constructor() {
        this.ApiUrl = "";
        this.ApiKey = "";
        this.ChatGPTModel = GptModel.GPT3_5_TURBO;
        this.MaxTokens = 0;
    }
}
export var GptModel;
(function (GptModel) {
    GptModel["GPT3_5_TURBO"] = "gpt-3.5-turbo";
    GptModel["GPT3_5_TURBO_16K"] = "gpt-3.5-turbo-16k";
    GptModel["GPT4"] = "gpt-4";
})(GptModel || (GptModel = {}));
export var ChatGptClientError;
(function (ChatGptClientError) {
    ChatGptClientError[ChatGptClientError["UnknownError"] = 0] = "UnknownError";
    ChatGptClientError[ChatGptClientError["ChatNotConfigured"] = 1] = "ChatNotConfigured";
    ChatGptClientError[ChatGptClientError["MessageNotSend"] = 2] = "MessageNotSend";
    ChatGptClientError[ChatGptClientError["InvalidMessageResponseFormat"] = 3] = "InvalidMessageResponseFormat";
})(ChatGptClientError || (ChatGptClientError = {}));
//# sourceMappingURL=IGptChat.js.map